import React from 'react';
import Main from '../components/Main';
import ProjectsRequest from '../components/ProjectsRequest';
import ProjectDescription from '../components/ProjectDescription';

// Project page

const Projects = () => {
  
  return (
    <Main componentList={[
      <h6 className="top_sentence">We’re currently hiring for the following roles</h6>,
      <ProjectsRequest />
    ]} full={true} />
  );
};

export default Projects;